import srpFlightResultsApi from '@/src/api/rtkQuery/srpFlightResults'
import type { AppDispatch } from '@/src/redux/store'
import { SearchResponse } from '@/src/types/flight'
import { MulticitySearchBody } from '@/src/types/searchQuery'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import useGetSearchQueryURL from '../getSearchQueryURL'

/**
 * Patches filter state on the active SRP results cache entry (OW/RT or multicity).
 */
const useUpdateSearchResultCache = () => {
    const { query, error: pastDateError, isMulticity, multicityBody } = useGetSearchQueryURL()

    const dispatch = useDispatch<AppDispatch>()

    const updateCache = useCallback(
        (updater: (currentData: SearchResponse | undefined) => SearchResponse) => {
            if (pastDateError) {
                return
            }

            if (isMulticity) {
                if (!multicityBody) {
                    return
                }
                dispatch(
                    srpFlightResultsApi.util.updateQueryData(
                        'getMulticityResults',
                        multicityBody as MulticitySearchBody,
                        updater
                    )
                )
                return
            }

            if (!query) {
                return
            }
            dispatch(srpFlightResultsApi.util.updateQueryData('getSrpResults', { query }, updater))
        },
        [dispatch, query, pastDateError, isMulticity, multicityBody]
    )

    return updateCache
}

export default useUpdateSearchResultCache
